import { render, staticRenderFns } from "./CheckinDetail.vue?vue&type=template&id=6af22a3e&"
import script from "./CheckinDetail.vue?vue&type=script&lang=js&"
export * from "./CheckinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports